import {
  BUSINESS_QUARTER_INFO,
  BUSINESS_VIP_INFO,
  BUSINESS_VIP_MONTH_INFO,
  PERSON_QUARTER_INFO,
  PERSON_VIP_INFO, PERSON_VIP_LIFELONG
} from "@/constant/VIP";
import {
  COMPANY_All_PURPOSE,
  COMPANY_All_PURPOSE_HALF,
  COMPANY_ONLINE,
  COMPANY_ONLINE_HALF
} from "@/constant/VIP_COMPANY";

const TITLE = {
  PERSON:'普通VIP：限学习交流，不可商用',
  BUSINESS:'商用VIP：个人商用授权+线上线下全用途',
  COMPANY:'企业全用途VIP：企业商用授权+线上线下全用途',
  COMPANY_ONLINE:'企业线上用途VIP：企业商用授权+线上用途',
}

export const VIP_EQUITY_LIST = [
  {
    id: PERSON_VIP_LIFELONG.ID,
    name: PERSON_VIP_LIFELONG.NAME,
    className:'PERSON',
    title: TITLE.PERSON + '（共4项授权）',
    user_crowd: PERSON_VIP_LIFELONG.USER_CROWD,
    equitySimple: [
      {
        isHas: true,
        label: '普通海量下载'
      },
      {
        isHas: true,
        label: '图片版权保障'
      },
      {
        isHas: 0,
        label: '商用授权使用'
      },
      {
        isHas: false,
        label: '图片包一键下载'
      }
    ],
    equityMore: [
      {
        isHas: 0,
        label: '商用授权使用'
      },
      {
        isHas: true,
        label: '普通海量下载'
      },
      {
        isHas: 0,
        label: '图片包一键下载'
      },
      {
        isHas: true,
        label: '图片版权保障'
      },
      {
        isHas: true,
        label: '在线申请发票'
      },
      {
        isHas: true,
        label: '专属客服1对1'
      },
      {
        isHas: 0,
        label: '新媒体用途'
      },
      {
        isHas: 0,
        label: '电商平台'
      },
      {
        isHas: 0,
        label: '线上推广'
      },
      {
        isHas: 0,
        label: '户外广告'
      },
      {
        isHas: 0,
        label: '线下印刷'
      },
      {
        isHas: 0,
        label: '图书出版'
      },
      {
        isHas: 0,
        label: '转售商品'
      },
      {
        isHas: 0,
        label: '影视制作'
      },
      {
        isHas: 0,
        label: '商标logo'
      },
      {
        isHas: 0,
        label: '敏感用途'
      },
      {
        isHas: 0,
        label: '产品内置'
      },
      {
        isHas: 0,
        label: '其他用途'
      }
    ],
    remark: '普通VIP_终身'
  },
  {
    id: PERSON_VIP_INFO.ID,
    name: PERSON_VIP_INFO.NAME,
    className:'PERSON',
    title: TITLE.PERSON + '（共4项授权）',
    user_crowd: PERSON_VIP_INFO.USER_CROWD,
    equitySimple: [
      {
        isHas: true,
        label: '普通海量下载'
      },
      {
        isHas: true,
        label: '图片版权保障'
      },
      {
        isHas: 0,
        label: '商用授权使用'
      },
      {
        isHas: false,
        label: '图片包一键下载'
      }
    ],
    equityMore: [
      {
        isHas: 0,
        label: '商用授权使用'
      },
      {
        isHas: true,
        label: '普通海量下载'
      },
      {
        isHas: 0,
        label: '图片包一键下载'
      },
      {
        isHas: true,
        label: '图片版权保障'
      },
      {
        isHas: true,
        label: '在线申请发票'
      },
      {
        isHas: true,
        label: '专属客服1对1'
      },
      {
        isHas: 0,
        label: '新媒体用途'
      },
      {
        isHas: 0,
        label: '电商平台'
      },
      {
        isHas: 0,
        label: '线上推广'
      },
      {
        isHas: 0,
        label: '户外广告'
      },
      {
        isHas: 0,
        label: '线下印刷'
      },
      {
        isHas: 0,
        label: '图书出版'
      },
      {
        isHas: 0,
        label: '转售商品'
      },
      {
        isHas: 0,
        label: '影视制作'
      },
      {
        isHas: 0,
        label: '商标logo'
      },
      {
        isHas: 0,
        label: '敏感用途'
      },
      {
        isHas: 0,
        label: '产品内置'
      },
      {
        isHas: 0,
        label: '其他用途'
      }
    ],
    remark: '普通VIP_年'
  },
  {
    id: PERSON_QUARTER_INFO.ID,
    name: PERSON_QUARTER_INFO.NAME,
    className:'PERSON',
    title: TITLE.PERSON + '（共4项授权）',
    user_crowd: PERSON_QUARTER_INFO.USER_CROWD,
    equitySimple: [
      {
        isHas: 1,
        label: '普通下载10张/天'
      },
      {
        isHas: true,
        label: '图片版权保障'
      },
      {
        isHas: 0,
        label: '商用授权使用'
      },
      {
        isHas: false,
        label: '图片包一键下载'
      }
    ],
    equityMore: [
      {
        isHas: 0,
        label: '商用授权使用'
      },
      {
        isHas: true,
        label: '普通下载10张/天'
      },
      {
        isHas: 0,
        label: '图片包一键下载'
      },
      {
        isHas: true,
        label: '图片版权保障'
      },
      {
        isHas: true,
        label: '在线申请发票'
      },
      {
        isHas: true,
        label: '专属客服1对1'
      },
      {
        isHas: 0,
        label: '新媒体用途'
      },
      {
        isHas: 0,
        label: '电商平台'
      },
      {
        isHas: 0,
        label: '线上推广'
      },
      {
        isHas: 0,
        label: '户外广告'
      },
      {
        isHas: 0,
        label: '线下印刷'
      },
      {
        isHas: 0,
        label: '图书出版'
      },
      {
        isHas: 0,
        label: '转售商品'
      },
      {
        isHas: 0,
        label: '影视制作'
      },
      {
        isHas: 0,
        label: '商标logo'
      },
      {
        isHas: 0,
        label: '敏感用途'
      },
      {
        isHas: 0,
        label: '产品内置'
      },
      {
        isHas: 0,
        label: '其他用途'
      }
    ],
    remark: '普通VIP_季'
  },
  {
    id: BUSINESS_VIP_INFO.ID,
    name: BUSINESS_VIP_INFO.NAME,
    className:'BUSINESS',
    title: TITLE.BUSINESS+ '（共12项授权）',
    user_crowd: BUSINESS_VIP_INFO.USER_CROWD,
    equitySimple: [
      {
        isHas: 1,
        label: '商用海量下载'
      },
      {
        isHas: true,
        label: '图片版权保障'
      },
      {
        isHas: 1,
        label: '商用授权使用'
      },
      {
        isHas: 1,
        label: '图片包一键下载'
      },
      {
        isHas: 1,
        label: '新媒体用途'
      },
      {
        isHas: 1,
        label: '电商平台'
      },
      {
        isHas: 1,
        label: '户外广告'
      },
      {
        isHas: 1,
        label: '印刷出版'
      },
    ],
    equityMore: [
      {
        isHas: true,
        label: '个人商用授权'
      },
      {
        isHas: true,
        label: '商用海量下载'
      },
      {
        isHas: 1,
        label: '图片包一键下载'
      },
      {
        isHas: true,
        label: '图片版权保障'
      },
      {
        isHas: true,
        label: '在线申请发票'
      },
      {
        isHas: true,
        label: '专属客服1对1'
      },
      {
        isHas: 1,
        label: '新媒体用途'
      },
      {
        isHas: 1,
        label: '电商平台'
      },
      {
        isHas: 1,
        label: '线上推广'
      },
      {
        isHas: 1,
        label: '户外广告'
      },
      {
        isHas: 1,
        label: '线下印刷限5万份'
      },
      {
        isHas: 1,
        label: '图书出版限10万份'
      },
      {
        isHas: 0,
        label: '转售商品'
      },
      {
        isHas: 0,
        label: '影视制作'
      },
      {
        isHas: 0,
        label: '商标logo'
      },
      {
        isHas: 0,
        label: '敏感用途'
      },
      {
        isHas: 0,
        label: '产品内置'
      },
      {
        isHas: 0,
        label: '其他用途'
      }
    ],
    remark: '商用VIP_年'
  },
  {
    id: BUSINESS_QUARTER_INFO.ID,
    name: BUSINESS_QUARTER_INFO.NAME,
    className:'BUSINESS',
    title: TITLE.BUSINESS + '（共11项授权）',
    user_crowd: BUSINESS_QUARTER_INFO.USER_CROWD,
    equitySimple: [
      {
        isHas: 1,
        label: '商用下载50张/天'
      },
      {
        isHas: true,
        label: '图片版权保障'
      },
      {
        isHas: 1,
        label: '商用授权使用'
      },
      {
        isHas: 0,
        label: '图片包一键下载'
      },
      {
        isHas: 1,
        label: '新媒体用途'
      },
      {
        isHas: 1,
        label: '电商平台'
      },
      {
        isHas: 1,
        label: '户外广告'
      },
      {
        isHas: 1,
        label: '印刷出版'
      },
    ],
    equityMore: [
      {
        isHas: true,
        label: '个人商用授权'
      },
      {
        isHas: true,
        label: '商用下载50张/天'
      },
      {
        isHas: 0,
        label: '图片包一键下载'
      },
      {
        isHas: true,
        label: '图片版权保障'
      },
      {
        isHas: true,
        label: '在线申请发票'
      },
      {
        isHas: true,
        label: '专属客服1对1'
      },
      {
        isHas: 1,
        label: '新媒体用途'
      },
      {
        isHas: 1,
        label: '电商平台'
      },
      {
        isHas: 1,
        label: '线上推广'
      },
      {
        isHas: 1,
        label: '户外广告'
      },
      {
        isHas: 1,
        label: '线下印刷限5万份'
      },
      {
        isHas: 1,
        label: '图书出版限10万份'
      },
      {
        isHas: 0,
        label: '转售商品'
      },
      {
        isHas: 0,
        label: '影视制作'
      },
      {
        isHas: 0,
        label: '商标logo'
      },
      {
        isHas: 0,
        label: '敏感用途'
      },
      {
        isHas: 0,
        label: '产品内置'
      },
      {
        isHas: 0,
        label: '其他用途'
      }
    ],
    remark: '商用VIP_季'
  },
  {
    id: BUSINESS_VIP_MONTH_INFO.ID,
    name: BUSINESS_VIP_MONTH_INFO.NAME,
    className:'BUSINESS',
    title: TITLE.BUSINESS + '（共11项授权）',
    user_crowd: BUSINESS_VIP_MONTH_INFO.USER_CROWD,
    equitySimple: [
      {
        isHas: 1,
        label: '商用下载10张/天'
      },
      {
        isHas: true,
        label: '图片版权保障'
      },
      {
        isHas: 1,
        label: '商用授权使用'
      },
      {
        isHas: 0,
        label: '图片包一键下载'
      },
      {
        isHas: 1,
        label: '新媒体用途'
      },
      {
        isHas: 1,
        label: '电商平台'
      },
      {
        isHas: 1,
        label: '户外广告'
      },
      {
        isHas: 1,
        label: '印刷出版'
      },
    ],
    equityMore: [
      {
        isHas: true,
        label: '个人商用授权'
      },
      {
        isHas: true,
        label: '商用下载10张/天'
      },
      {
        isHas: 0,
        label: '图片包一键下载'
      },
      {
        isHas: true,
        label: '图片版权保障'
      },
      {
        isHas: true,
        label: '在线申请发票'
      },
      {
        isHas: true,
        label: '专属客服1对1'
      },
      {
        isHas: 1,
        label: '新媒体用途'
      },
      {
        isHas: 1,
        label: '电商平台'
      },
      {
        isHas: 1,
        label: '线上推广'
      },
      {
        isHas: 1,
        label: '户外广告'
      },
      {
        isHas: 1,
        label: '线下印刷限5万份'
      },
      {
        isHas: 1,
        label: '图书出版限10万份'
      },
      {
        isHas: 0,
        label: '转售商品'
      },
      {
        isHas: 0,
        label: '影视制作'
      },
      {
        isHas: 0,
        label: '商标logo'
      },
      {
        isHas: 0,
        label: '敏感用途'
      },
      {
        isHas: 0,
        label: '产品内置'
      },
      {
        isHas: 0,
        label: '其他用途'
      }
    ],
    remark: '商用VIP_月'
  },
  {
    id: COMPANY_ONLINE.ID,
    name: COMPANY_ONLINE.NAME,
    className:'COMPANY',
    title: TITLE.COMPANY_ONLINE + '（共9项授权）',
    user_crowd: COMPANY_ONLINE.USER_CROWD,
    equitySimple: [
      {
        isHas: 1,
        label: '商用海量下载'
      },
      {
        isHas: true,
        label: '图片版权保障'
      },
      {
        isHas: 1,
        label: '商用授权使用'
      },
      {
        isHas: 1,
        label: '图片包一键下载'
      },
      {
        isHas: 1,
        label: '新媒体用途'
      },
      {
        isHas: 1,
        label: '电商平台'
      },
      {
        isHas: 0,
        label: '户外广告'
      },
      {
        isHas: 0,
        label: '印刷出版'
      },
    ],
    equityMore: [
      {
        isHas: true,
        label: '企业商用授权'
      },
      {
        isHas: true,
        label: '商用海量下载'
      },
      {
        isHas: 1,
        label: '图片包一键下载'
      },
      {
        isHas: true,
        label: '图片版权保障'
      },
      {
        isHas: true,
        label: '在线申请发票'
      },
      {
        isHas: true,
        label: '专属客服1对1'
      },
      {
        isHas: 1,
        label: '新媒体用途'
      },
      {
        isHas: 1,
        label: '电商平台'
      },
      {
        isHas: 1,
        label: '线上推广'
      },
      {
        isHas: 0,
        label: '户外广告'
      },
      {
        isHas: 0,
        label: '线下印刷'
      },
      {
        isHas: 0,
        label: '图书出版'
      },
      {
        isHas: 0,
        label: '转售商品'
      },
      {
        isHas: 0,
        label: '影视制作'
      },
      {
        isHas: 0,
        label: '商标logo'
      },
      {
        isHas: 0,
        label: '敏感用途'
      },
      {
        isHas: 0,
        label: '产品内置'
      },
      {
        isHas: 0,
        label: '其他用途'
      }
    ],
    remark: '线上用途_年'
  },
  {
    id: COMPANY_ONLINE_HALF.ID,
    name: COMPANY_ONLINE_HALF.NAME,
    className:'COMPANY',
    title: TITLE.COMPANY_ONLINE + '（共9项授权）',
    // user_crowd: COMPANY_ONLINE_HALF.USER_CROWD,
    equitySimple: [
      {
        isHas: 1,
        label: '商用海量下载'
      },
      {
        isHas: true,
        label: '图片版权保障'
      },
      {
        isHas: 1,
        label: '商用授权使用'
      },
      {
        isHas: 1,
        label: '图片包一键下载'
      },
      {
        isHas: 1,
        label: '新媒体用途'
      },
      {
        isHas: 1,
        label: '电商平台'
      },
      {
        isHas: 0,
        label: '户外广告'
      },
      {
        isHas: 0,
        label: '印刷出版'
      },
    ],
    equityMore: [
      {
        isHas: true,
        label: '企业商用授权'
      },
      {
        isHas: true,
        label: '商用海量下载'
      },
      {
        isHas: 1,
        label: '图片包一键下载'
      },
      {
        isHas: true,
        label: '图片版权保障'
      },
      {
        isHas: true,
        label: '在线申请发票'
      },
      {
        isHas: true,
        label: '专属客服1对1'
      },
      {
        isHas: 1,
        label: '新媒体用途'
      },
      {
        isHas: 1,
        label: '电商平台'
      },
      {
        isHas: 1,
        label: '线上推广'
      },
      {
        isHas: 0,
        label: '户外广告'
      },
      {
        isHas: 0,
        label: '线下印刷'
      },
      {
        isHas: 0,
        label: '图书出版'
      },
      {
        isHas: 0,
        label: '转售商品'
      },
      {
        isHas: 0,
        label: '影视制作'
      },
      {
        isHas: 0,
        label: '商标logo'
      },
      {
        isHas: 0,
        label: '敏感用途'
      },
      {
        isHas: 0,
        label: '产品内置'
      },
      {
        isHas: 0,
        label: '其他用途'
      }
    ],
    remark: '线上用途_半年'
  },
  {
    id: COMPANY_All_PURPOSE.ID,
    name: COMPANY_All_PURPOSE.NAME,
    className:'COMPANY',
    title: TITLE.COMPANY + '（共12项授权）',
    // user_crowd: COMPANY_All_PURPOSE.USER_CROWD,
    equitySimple: [
      {
        isHas: 1,
        label: '商用海量下载'
      },
      {
        isHas: true,
        label: '图片版权保障'
      },
      {
        isHas: 1,
        label: '商用授权使用'
      },
      {
        isHas: 1,
        label: '图片包一键下载'
      },
      {
        isHas: 1,
        label: '新媒体用途'
      },
      {
        isHas: 1,
        label: '电商平台'
      },
      {
        isHas: 1,
        label: '户外广告'
      },
      {
        isHas: 1,
        label: '印刷出版'
      },
    ],
    equityMore: [
      {
        isHas: true,
        label: '企业商用授权'
      },
      {
        isHas: true,
        label: '商用海量下载'
      },
      {
        isHas: 1,
        label: '图片包一键下载'
      },
      {
        isHas: true,
        label: '图片版权保障'
      },
      {
        isHas: true,
        label: '在线申请发票'
      },
      {
        isHas: true,
        label: '专属客服1对1'
      },
      {
        isHas: 1,
        label: '新媒体用途'
      },
      {
        isHas: 1,
        label: '电商平台'
      },
      {
        isHas: 1,
        label: '线上推广'
      },
      {
        isHas: 1,
        label: '户外广告'
      },
      {
        isHas: 1,
        label: '线下印刷限5万份'
      },
      {
        isHas: 1,
        label: '图书出版限10万份'
      },
      {
        isHas: 0,
        label: '转售商品'
      },
      {
        isHas: 0,
        label: '影视制作'
      },
      {
        isHas: 0,
        label: '商标logo'
      },
      {
        isHas: 0,
        label: '敏感用途'
      },
      {
        isHas: 0,
        label: '产品内置'
      },
      {
        isHas: 0,
        label: '其他用途'
      }
    ],
    remark: '线上线下全用途_年'
  },
  {
    id: COMPANY_All_PURPOSE_HALF.ID,
    name: COMPANY_All_PURPOSE_HALF.NAME,
    className:'COMPANY',
    title: TITLE.COMPANY + '（共12项授权）',
    // user_crowd: COMPANY_All_PURPOSE_HALF.USER_CROWD,
    equitySimple: [
      {
        isHas: 1,
        label: '商用海量下载'
      },
      {
        isHas: true,
        label: '图片版权保障'
      },
      {
        isHas: 1,
        label: '商用授权使用'
      },
      {
        isHas: 1,
        label: '图片包一键下载'
      },
      {
        isHas: 1,
        label: '新媒体用途'
      },
      {
        isHas: 1,
        label: '电商平台'
      },
      {
        isHas: 1,
        label: '户外广告'
      },
      {
        isHas: 1,
        label: '印刷出版'
      },
    ],
    equityMore: [
      {
        isHas: true,
        label: '企业商用授权'
      },
      {
        isHas: true,
        label: '商用海量下载'
      },
      {
        isHas: 1,
        label: '图片包一键下载'
      },
      {
        isHas: true,
        label: '图片版权保障'
      },
      {
        isHas: true,
        label: '在线申请发票'
      },
      {
        isHas: true,
        label: '专属客服1对1'
      },
      {
        isHas: 1,
        label: '新媒体用途'
      },
      {
        isHas: 1,
        label: '电商平台'
      },
      {
        isHas: 1,
        label: '线上推广'
      },
      {
        isHas: 1,
        label: '户外广告'
      },
      {
        isHas: 1,
        label: '线下印刷限5万份'
      },
      {
        isHas: 1,
        label: '图书出版限10万份'
      },
      {
        isHas: 0,
        label: '转售商品'
      },
      {
        isHas: 0,
        label: '影视制作'
      },
      {
        isHas: 0,
        label: '商标logo'
      },
      {
        isHas: 0,
        label: '敏感用途'
      },
      {
        isHas: 0,
        label: '产品内置'
      },
      {
        isHas: 0,
        label: '其他用途'
      }
    ],
    remark: '线上线下全用途_半年'
  },
]
